import { BodyText, Tooltip } from "@/components/ui";
import { Button } from "@/components/ui/Button";
import { cn } from "@/lib/utils";
import type { ServiceRequest } from "@curai/js-fhir-tools";
import { LoaderCircle, Trash2 } from "lucide-react";
import { useRemoveTestFromOrder } from "../network/useRemoveTestFromOrder";

export const TestEntry = ({
  serviceRequest,
  readOnly,
  patientId,
  encounterId,
  requestGroupId,
}: {
  serviceRequest: ServiceRequest;
  readOnly: boolean;
  patientId: string;
  encounterId: string;
  requestGroupId: string;
}) => {
  const { mutate: removeTest, isPending } = useRemoveTestFromOrder({
    patientId,
    encounterId,
    requestGroupId,
    serviceRequestId: serviceRequest.id as string,
  });

  return (
    <div className="flex flex-row justify-between items-center">
      <BodyText size="sm">{serviceRequest.testName}</BodyText>
      <Tooltip tooltipContentText="Remove From Order">
        <Button
          variant="icon"
          className="m-0 ml-1 p-0 h-4 cursor-pointer"
          disabled={isPending || readOnly}
          onClick={() => {
            if (isPending) return;
            removeTest();
          }}
        >
          {isPending ? (
            <LoaderCircle className="h-4 w-4 animate-spin stroke-tertiary" />
          ) : (
            <Trash2
              className={cn(
                readOnly
                  ? "stroke-tertiary cursor-not-allowed"
                  : "stroke-error",
              )}
              size={16}
            />
          )}
        </Button>
      </Tooltip>
    </div>
  );
};
